import { useEffect, useState } from 'react';
import classes from './LoginPage.module.css';

const INTERVAL_MS = 5000;

function slideUrl(src) {
  const base = process.env.PUBLIC_URL || '';
  return src.startsWith('/') ? `${base}${src}` : `${base}/${src}`;
}

function preloadImage(src) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(src);
    img.onerror = () => resolve(src);
    img.src = src;
  });
}

export default function LoginHeroCarousel() {
  const [slides, setSlides] = useState([]);
  const [index, setIndex] = useState(0);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    fetch('/api/login-carousel/slides')
      .then((r) => r.json())
      .then(async (d) => {
        if (cancelled || !d.success || !Array.isArray(d.data) || !d.data.length) return;
        const list = d.data;
        // Affiche dès que la 1ʳᵉ image est prête — le reste en arrière-plan
        await preloadImage(slideUrl(list[0].src));
        if (cancelled) return;
        setSlides(list);
        setIndex(0);
        setReady(true);
        list.slice(1).forEach((slide) => {
          preloadImage(slideUrl(slide.src));
        });
      })
      .catch(() => {
        if (!cancelled) setSlides([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!ready || slides.length <= 1) return undefined;

    const timer = setInterval(
      () => setIndex((current) => (current + 1) % slides.length),
      INTERVAL_MS,
    );
    return () => clearInterval(timer);
  }, [ready, slides.length]);

  if (!slides.length) return null;

  return (
    <div className={classes.carousel} aria-hidden="true">
      {slides.map((slide, i) => (
        <div
          key={slide.src}
          className={`${classes.carouselSlide} ${i === index ? classes.carouselSlideActive : ''}`}
          style={{ backgroundImage: `url("${slideUrl(slide.src)}")` }}
          role="img"
          aria-label={slide.alt}
        />
      ))}
      <div className={classes.heroOverlay} />
    </div>
  );
}
